import { execSync } from 'node:child_process';
import { existsSync } from 'node:fs';

export interface HostSecurityInfo {
  os: string;
  firewall_enabled: boolean | null;
  firewall_stealth: boolean | null;
  firewall_block_all: boolean | null;
}

const SOCKETFILTERFW = '/usr/libexec/ApplicationFirewall/socketfilterfw';

function runCommand(cmd: string): string | null {
  try {
    return execSync(cmd, { timeout: 5000, encoding: 'utf-8' }).trim();
  } catch {
    return null;
  }
}

function parseBool(
  output: string | null,
  enabledPattern: RegExp,
  disabledPattern: RegExp,
): boolean | null {
  if (!output) return null;
  if (enabledPattern.test(output)) return true;
  if (disabledPattern.test(output)) return false;
  return null;
}

/**
 * Detect macOS Application Firewall state.
 * Returns null on non-macOS or if detection fails.
 */
export function detectHostSecurity(): HostSecurityInfo | null {
  const os = runCommand('uname -s');
  if (os !== 'Darwin') return null;

  if (!existsSync(SOCKETFILTERFW)) return null;

  const globalState = runCommand(`${SOCKETFILTERFW} --getglobalstate`);
  if (!globalState) return null;

  const stealthMode = runCommand(`${SOCKETFILTERFW} --getstealthmode`);
  const blockAll = runCommand(`${SOCKETFILTERFW} --getblockall`);

  return {
    os: 'darwin',
    firewall_enabled: parseBool(globalState, /\benabled\b/i, /\bdisabled\b/i),
    firewall_stealth: parseBool(stealthMode, /\bon\b/i, /\boff\b/i),
    firewall_block_all: parseBool(blockAll, /\benabled\b/i, /\bdisabled\b/i),
  };
}
